import type { ContextExpression } from '@trackback/widgets';
import { createNamedExpressionResolver } from '../types';

export const contextResolver = createNamedExpressionResolver<ContextExpression>(
  'context',
  (_parser, options, onData) => onData.next(options.context ?? {})
);
